import {
  CmsBaseComponent,
  CmsProduct,
  ComponentProductMetadata,
} from '$/(cms)/_modules/cmsService/types';

/**
 * Deliberately not `findComponentByType`: a ProductMetaConfig nested in a
 * Prefilled Block is scoped to that block, so only a top-level one is the page's.
 */
export const getPageProductMetaConfig = (
  components: CmsBaseComponent[] | undefined,
): ComponentProductMetadata | undefined =>
  components?.find(
    (c): c is ComponentProductMetadata =>
      c.__typename === 'ComponentPagesComponentProductMetaConfig',
  );

/**
 * The apply link a page's Product Meta Config sets for `product` — its product block's
 * `override_cta_link`, the one the page's cards, its comparison table rows and the legacy product
 * panel send the product's Apply to.
 */
export const getProductMetaConfigCtaLinkOverride = (
  config: ComponentProductMetadata | undefined,
  product: Pick<CmsProduct, 'uid'> | undefined,
): string | undefined =>
  product?.uid
    ? config?.product_card?.find(
        (card) => card.productBlock?.product?.uid === product.uid,
      )?.productBlock?.override_cta_link
    : undefined;
